// Centralized theme configuration for colors, typography, and spacing
export const theme = {
  // Color palette — WODGoat brand
  colors: {
    // Primary orange
    primary: '#FF6B2C',
    primaryDark: '#E65724',
    primaryLight: '#FFB089',

    // Secondary dark
    secondary: '#2E2E2E',
    secondaryDark: '#1C1C1C',

    // Accent yellow
    accent: '#FFD60A',
    accentLink: '#F8E805',

    // Backgrounds (dark theme)
    background: '#1C1C1E',
    backgroundSecondary: '#2E2E2E',
    backgroundGray: '#2E2E2E',
    backgroundTertiary: '#FAFAFA',

    // Text
    text: '#E6EDF3',
    textSecondary: '#8E8E93',
    textLight: '#C7C7CC',
    textInverse: '#FFFFFF',

    // Borders
    border: '#3A3A3C',
    borderLight: '#E5E5EA',
    borderFocus: '#F8E805',

    // Status
    success: '#34C759',
    error: '#FF3B30',
    warning: '#FFD60A',

    // Fitness-specific
    cardio: '#FF6B6B',
    strength: '#4ECDC4',
    flexibility: '#45B7D1',

    // Neutrals
    white: '#FFFFFF',
    black: '#000000',
    neutral100: '#F2F2F7',
    neutral500: '#8E8E93',
    neutral800: '#1C1C1E',
  },

  // Typography
  typography: {
    fontFamily: {
      primary: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      heading: "'Poppins', 'League Spartan', sans-serif",
      mono: "'Space Mono', 'Courier New', monospace",
    },
    fontSize: {
      xs: '0.75rem',      // 12px
      sm: '0.875rem',     // 14px
      base: '1rem',       // 16px
      lg: '1.125rem',     // 18px
      xl: '1.25rem',      // 20px
      '2xl': '1.5rem',    // 24px
      '3xl': '1.875rem',  // 30px
      '4xl': '2.25rem',   // 36px
      '5xl': '3rem',      // 48px
      '6xl': '3.75rem',   // 60px
      '7xl': '4.5rem',    // 72px
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.75,
    },
  },

  // Spacing
  spacing: {
    xs: '0.5rem',    // 8px
    sm: '1rem',      // 16px
    md: '1.5rem',    // 24px
    lg: '2rem',      // 32px
    xl: '3rem',      // 48px
    '2xl': '4rem',   // 64px
    '3xl': '6rem',   // 96px
    '4xl': '8rem',   // 128px
  },

  // Border radius
  borderRadius: {
    none: '0',
    sm: '0.25rem',   // 4px
    base: '0.5rem',  // 8px
    md: '0.75rem',   // 12px
    lg: '1rem',      // 16px
    xl: '1.5rem',    // 24px
    full: '9999px',
  },

  // Breakpoints for responsive design
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px',
  },

  // Shadows (deeper for dark theme)
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.25)',
    base: '0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 1px 2px 0 rgba(0, 0, 0, 0.2)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.35), 0 4px 6px -2px rgba(0, 0, 0, 0.2)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.4), 0 10px 10px -5px rgba(0, 0, 0, 0.25)',
  },

  // Transitions
  transitions: {
    fast: '150ms ease-in-out',
    base: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
};

export default theme;
